import { useContext } from 'react'
import { FindMemberContext, MyClaimsContext, OverviewWidgetContext, ToggleContext } from '@typesApp/WidgetContextHolder'
import { WidgetContext } from './widgetContext'

export const useToggleWidgetContext = (): ToggleContext => {
  const context = useContext(WidgetContext)
  return context.toggle ?? {}
}

export const useOverviewWidgetContext = (): OverviewWidgetContext => {
  const context = useContext(WidgetContext)
  return context.overviewWidget ?? {}
}

export const useFindMemberContext = (): FindMemberContext => {
  const context = useContext(WidgetContext)
  return context.findMember ?? {}
}

export const useMyClaimsContext = (): MyClaimsContext => {
  const context = useContext(WidgetContext)
  return context.myClaims ?? {}
}
